<template>
  <!-- NOTE (TEMPLATE) personalized gantt chart -->

  <div>
    <!-- <div>{{test}}</div>
    زمان شروع: {{items.length > 0 ? moment(new Date(Math.min(...items.map(x=> new Date(
    moment(x.startDate, 'jYYYY/jMM/jDD').format('YYYY-MM-DD')
    ).getTime())))).format('jYYYY/jMM/jDD') : ''}}
    <br />
    زمان پایان: {{items.length > 0 ? moment(new Date(Math.max(...items.map(x=> new Date(
    moment(x.dueDate, 'jYYYY/jMM/jDD').format('YYYY-MM-DD')
    ).getTime())))).format('jYYYY/jMM/jDD') : ''}}-->
    <b-table
      responsive
      sticky-header
      small
      show-empty
      head-variant="light"
      bordered
      :items="computedItems"
      :fields="computedFields"
      empty-text="برای نمایش گانت چارت ابتدا باید فعالیت ها و مقادیر مربوطه را تعریف نمایید"
      class="table"
    >
      <template v-slot:thead-top="data">
        <tr>
          <b-th variant="primary" colspan="2"></b-th>
          <b-th v-for="year in yearsCount" :key="year.year" variant="danger" :colspan="year.count">
            <div style="text-align:center;vertical-align:middle; ">{{year.year}}</div>
          </b-th>
        </tr>
      </template>
      <template v-slot:head(index)="data">
        <div class="text-nowrap">#</div>
      </template>
      <!-- <template v-slot:head()="scope">
        <div class="text-nowrap">Heading</div>
      </template>-->
      <template v-slot:cell(index)="data">
        <div
          class="text-nowrap"
          style="text-align:center;vertical-align:middle; "
        >{{ (data.index + 1 ) }}</div>
      </template>
      <template v-slot:cell(description)="data">
        <div style="text-align:center;vertical-align:middle; ">{{ (data.value ) }} (وزن: {{data.item.percent}}%)</div>
      </template>
      <template v-slot:cell(startDate)="data">
        <div style="text-align:center;vertical-align:middle; ">{{ (data.value ) }}</div>
      </template>
      <template v-slot:cell(dueDate)="data">
        <div style="text-align:center;vertical-align:middle; ">{{ (data.value ) }}</div>
      </template>
      <!-- <template v-slot:cell(report)="data">
        <b-form-checkbox
         
          v-model="data.item.value"
          title="heyyyy"
          id="tooltip-target-1"
        ></b-form-checkbox>
        <b-tooltip
          target="tooltip-target-1"
        >درصورت ارائه گزارش در پایان این فاز به ستاد، انتخاب نمایید</b-tooltip>
        
      </template>-->
      <template v-slot:cell()="data">
        <b-button
          class="btn-block rounded-0"
          disabled
          v-show="data.value"
          v-bind:style="{width:'100%',margin:0,padding:0,backgroundColor:data.item.cellColor,height:'30px'}"
        ></b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
import moment from "moment-jalaali";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

function monthDiff(d1, d2) {
  var months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
}

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}
export default {
  props: ["items", "fields"],
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      moment: moment,
      persianMonths: [
        { index: 1, name: "فروردین" },
        { index: 2, name: "اردیبهشت" },
        { index: 3, name: "خرداد" },
        { index: 4, name: "تیر" },
        { index: 5, name: "مرداد" },
        { index: 6, name: "شهریور" },
        { index: 7, name: "مهر" },
        { index: 8, name: "آبان" },
        { index: 9, name: "آذر" },
        { index: 10, name: "دی" },
        { index: 11, name: "بهمن" },
        { index: 12, name: "اسفند" },
      ],
      yearsCount: [],
      // myTd: {
      //   padding: 0,
      //   margin: 0,
      //   width: "250px",
      //   backgroundColor: "black",
      //   textAlign: "center",
      // },
    };
  },
  computed: {
    computedItems() {
      if (this.items.length == 0) return this.items;
      let myItems = [];
      this.items.map(function (x, index) {
        myItems.push({
          description: x.description,
          cellColor: x.cellColor,
          startDate: x.startDate,
          dueDate: x.dueDate,
          percent: x.percent
        });

        let tempStart = x.startDate;
        let tempFinish = x.dueDate;
        let monthDiff = 0;
        if (
          tempFinish.toString().split("/")[0] -
            tempStart.toString().split("/")[0] ==
          0
        ) {
          monthDiff =
            tempFinish.toString().split("/")[1] -
            tempStart.toString().split("/")[1];
        } else {
          monthDiff =
            (tempFinish.toString().split("/")[0] -
              tempStart.toString().split("/")[0]) *
              12 +
            (tempFinish.toString().split("/")[1] -
              tempStart.toString().split("/")[1]);
        }
        let Monthfields = [];
        let tempStartYear = tempStart.split("/")[0];
        let tempFinishYear = tempFinish.split("/")[0];

        let yearCnt = 0;
        let tempStartMonth = tempStart.split("/")[1];
        let tempFinishMonth = tempFinish.split("/")[1];

        for (let year = tempStartYear; year <= tempFinishYear; year++) {
          if (year == tempStartYear && year != tempFinishYear) {
            for (let month = Number(tempStartMonth); month <= 12; month++) {
              myItems[index][String(year) + String(month)] = "x";
              // myItems[index]["_cellVariants"][String(year) + String(month)] =
              //   x.cellColor;
              // Monthfields.push({ year: Number(year), month: month });
            }
          } else if (year == tempStartYear && year == tempFinishYear) {
            for (
              let month = Number(tempStartMonth);
              month <= Number(tempFinishMonth);
              month++
            ) {
              myItems[index][String(year) + String(month)] = "x";
              // myItems[index]["_cellVariants"][String(year) + String(month)] =
              //   x.cellColor;
              // Monthfields.push({ year: Number(year), month: month });
            }
          } else if (year > tempStartYear && year < tempFinishYear) {
            for (let month = 1; month <= 12; month++) {
              myItems[index][String(year) + String(month)] = "x";
              // myItems[index]["_cellVariants"][String(year) + String(month)] =
              //   x.cellColor;
              // Monthfields.push({ year: year, month: month });
            }
          } else if (year == tempFinishYear) {
            for (let month = 1; month <= Number(tempFinishMonth); month++) {
              myItems[index][String(year) + String(month)] = "x";
              // myItems[index]["_cellVariants"][String(year) + String(month)] =
              //   x.cellColor;
              // Monthfields.push({ year: year, month: month });
            }
          }
          // myItems[index][i] = 'x'
        }
      });

      return myItems;
    },
    computedFields() {
      if (this.items.length == 0) return this.items;
      let startDate = new Date(
        this.items
          .map((x) =>
            new Date(moment(x.startDate, "jYYYY/jMM/jDD").format()).getTime()
          )
          .sort((a, b) => a - b)[0]
      );

      let finishDate = new Date(
        this.items
          .map((x) =>
            new Date(moment(x.dueDate, "jYYYY/jMM/jDD").format()).getTime()
          )
          .sort((a, b) => b - a)[0]
      );

      let tempStart = moment(startDate).format("jYYYY/jM/jD");
      let tempFinish = moment(finishDate).format("jYYYY/jM/jD");
      let monthDiff = 0;
      if (
        tempFinish.toString().split("/")[0] -
          tempStart.toString().split("/")[0] ==
        0
      ) {
        monthDiff =
          tempFinish.toString().split("/")[1] -
          tempStart.toString().split("/")[1];
      } else {
        monthDiff =
          (tempFinish.toString().split("/")[0] -
            tempStart.toString().split("/")[0]) *
            12 +
          (tempFinish.toString().split("/")[1] -
            tempStart.toString().split("/")[1]);
      }
      let Monthfields = [];
      let tempStartYear = tempStart.split("/")[0];
      let tempFinishYear = tempFinish.split("/")[0];

      let yearCnt = 0;
      let tempStartMonth = tempStart.split("/")[1];
      let tempFinishMonth = tempFinish.split("/")[1];

      for (let year = tempStartYear; year <= tempFinishYear; year++) {
        if (year == tempStartYear && year != tempFinishYear) {
          for (let month = Number(tempStartMonth); month <= 12; month++) {
            Monthfields.push({
              year: Number(year),
              month: month,
            });
          }
        } else if (year == tempStartYear && year == tempFinishYear) {
          for (
            let month = Number(tempStartMonth);
            month <= Number(tempFinishMonth);
            month++
          ) {
            Monthfields.push({
              year: Number(year),
              month: month,
            });
          }
        } else if (year > tempStartYear && year < tempFinishYear) {
          for (let month = 1; month <= 12; month++) {
            Monthfields.push({
              year: year,
              month: month,
            });
          }
        } else if (year == tempFinishYear) {
          for (let month = 1; month <= Number(tempFinishMonth); month++) {
            Monthfields.push({
              year: year,
              month: month,
            });
          }
        }
      }
      let myFields = [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌" },
        { key: "startDate", label: "تاریخ آغاز" },
        { key: "dueDate", label: "تاریخ پایان" },
      ];
      let newFields = [];
      // console.log(Monthfields);
      let yearsCount = Monthfields.map((x) => x.year).filter(onlyUnique);
      this.yearsCount = yearsCount.map((x) => {
        return {
          year: x,
          count: Monthfields.filter((y) => y.year == x).length,
        };
      });
      function myFunc(value, key, item) {
        return [{ value: "red", key: "background-color" }];
      }
      Monthfields.forEach((x, index) => {
        newFields.push({
          label: this.persianMonths.filter((y) => y.index == x.month)[0].name,
          key: String(x.year) + String(x.month),
          cssClass: {
            backgroundColor: "red",
          },
          cellColor: x.cellColor,
          tdClass: "myTd",
        });
      });
      newFields.unshift(
        { key: "index", label: "#", stickyColumn: true },
        {
          key: "description",
          label: "شرح فعالیت‌",
          stickyColumn: true,
        }
        // {
        //   key: "startDate",
        //   label: "تاریخ آغاز",
        //   stickyColumn: true,
        // },
        // {
        //   key: "dueDate",
        //   label: "تاریخ پایان",
        //   stickyColumn: true,
        // }
      );
      // console.log({ newFields });
      return newFields;
    },
  },
  methods: {},
  mounted() {},
};
</script>

<style>
.table-column {
  width: 250px;
  background-color: black;
  text-align: center;
}
.myTd {
  padding: 0 !important;
  margin: 0 !important;
  /* width: 250px; */

  text-align: center;
}
.table {
  text-align: center;
  width: 100%;
  margin: 0;
  padding: 0;
}

td {
  padding: 0;
}
</style>